import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import store from "../store";
import LoginView from "../views/Login/LoginView.vue";
import ForgotPassword from "../views/Login/ForgotPassword.vue";
import SetPassword from "@/views/Login/SetPassword.vue";
import SelectBusiness from "@/views/Business/SelectBusiness.vue";
import SelectLocation from "@/views/Business/SelectLocation.vue";
import AddBusiness from "@/views/Business/AddBusiness.vue";

// Pages
import Dashboard from "@/views/Dashboard/Index.vue";

// Products
import Products from "@/views/Products/Product/Products.vue";
import Categories from "@/views/Products/Category/Regular.vue";
import FeaturedCategories from "@/views/Products/Category/Featured.vue";
import ProductEdits from "@/views/Products/ProductEdits.vue";

// Master Product
import MasterProducts from "@/views/Products/MasterProduct/MasterProductList.vue";

// Purchase Order
// import PurchaseOrder from "@/views/Products/PurchaseOrder/PurchaseOrder.vue";
import PurchaseOrderV2 from "@/views/Products/PurchaseOrder/PurchaseOrderV2.vue";
import AddPurchaseOrder from '@/views/Products/PurchaseOrder/PurchaseOrderAdd.vue';
import ViewPurchaseOrder from '@/views/Products/PurchaseOrder/PurchaseOrderView.vue';

// Product Promotions
import ProductPromotions from "@/views/Products/Promotions/Index.vue";
import ProductDiscounts from "@/views/Products/Discounts/Index.vue";
import ProductSales from "@/views/Products/Sales/Index.vue";
import ProductReasonCode from "@/views/Products/ReasonCode/Index.vue";

// Employees
import Employees from "@/views/Employees/Employees.vue";

// Locations
import Location from "../views/Location/index.vue";
import LocationInfo from "../views/Location/Info.vue";
import LocationDevicesPos from "@/views/Location/Devices/Pos.vue";
import LocationDeviceScanner from "@/views/Location/Devices/Scanner.vue";
import LocationPickup from "@/views/Location/Pickup.vue";
import LocationHolidays from "../views/Location/Holiday/Index.vue";
import CloverResponse from "../views/Location/Clover.vue";

// locations delivery
import LocationDeliverySetting from "../views/Location/Delivery/DeliverySetting.vue";
import LocationDeliveryHours from "../views/Location/Delivery/DeliveryHours.vue";
import LocationDeliveryZone from "../views/Location/Delivery/DeliveryZone.vue";
import LocationIntegrationCRM from "@/views/Location/Integrations/CRM.vue";
import LocationIntegrationAccessToken from "@/views/Location/Integrations/AccessToken/Index.vue";
import LocationComplianceSettings from "@/views/Location/Integrations/ComplianceSettings.vue";
import Marketplace from "@/views/Location/Integrations/Marketplace.vue";

import LocationIntegrationPayment from "@/views/Location/Integrations/Payment.vue";
import LocationMessageBanner from "@/views/Location/MessageBanner.vue";
import PriceMarkupSetting from "@/views/Location/PriceMarkupSetting.vue";

// Tax
import BusinessTaxes from "@/views/Tax/Index.vue";

// Security roles
import SecurityRoles from "../views/SecurityRoles/SecurityRoles.vue";

// Analytics and reports
import ReportDashboard from "@/views/Reports/Dashboard.vue";
import ReportGeneration from "@/views/Reports/ReportGeneration/Index.vue";
import SalesMain from "@/views/Reports/Sales/Index.vue";
import InventorySnapShots from "@/views/Reports/InventorySnapShots/index.vue";
import PurchaseOrderReport from "@/views/Reports/PurchaseOrder/index.vue";
import InvoiceReport from "@/views/Reports/InvoiceReport.vue";
import Discounts from "@/views/Reports/Discounts.vue";
import InventoryLog from "@/views/Reports/InventoryLog.vue";
import Taxes from "@/views/Reports/Taxes.vue";
import TransferReport from "@/views/Reports/Transfer.vue";
import EodSummary from "@/views/Reports/EodSummary/EodSummary.vue";

//Cash Mgmt.
import EndOfDay from "@/views/CashMgmt/EndOfDay/Index.vue";
import CurrentVault from "@/views/CashMgmt/Vault/CurrentVault.vue";
import TransactionHistory from "@/views/CashMgmt/Vault/TransactionHistory.vue";

//Inventory
import ProductAudits from "@/views/Inventory/Audits/Index.vue";
import ProductAuditsView from "@/views/Inventory/Audits/View/Index.vue";
import ComplianceReport from "@/views/Inventory/Audits/Report/Index.vue";
import InventoryOverview from "@/views/Inventory/InventoryOverview/Index.vue";
import Transfer from "@/views/Inventory/Transfer/Transfer.vue";
import NewInventoryTransfers from "@/views/Inventory/Transfer/NewInventoryTransfer.vue";
import EditInventoryTransfers from "@/views/Inventory/Transfer/EditInventoryTransfer.vue";
import ReceiveTransfer from "@/views/Inventory/Transfer/ReceiveTransfer.vue";
import LocationCannabisSettings from "@/views/Inventory/InventorySettings.vue";

// Settings
import GeneralSettings from "../views/Settings/GeneralSettings.vue";
import SettingGeneralProfile from '../views/Settings/General/Profiles.vue'
import SettingGeneralBusiness from '../views/Settings/General/BusinessSettings.vue'
import PricingGroup from "../views/Settings/PricingGroup/Index.vue";
import BusinessCannabisSettings from "@/views/Settings/BusinessCannabisSettings.vue";
import EodReports from "@/views/Settings/Reports.vue";
import RouteType from "../types/routeType";
import Banner from "@/views/Settings/Banner/Banner.vue";
import SeoSettings from "@/views/Settings/SeoSettings.vue";
import WebsiteSettings from "@/views/Settings/WebsiteSettings.vue";

import CustomerImport from "@/views/Settings/Tools/CustomersTab.vue";
import ProductImport from "@/views/Settings/Tools/ProductTab.vue";
import PurchaseOrderAIPrompts from '@/views/Settings/Tools/PurchaseOrderAIPrompts.vue'

// Membership
import MembershipCustomers from "@/views/Membership/Customer/Index.vue";
import MembershipSetting from "@/views/Membership/Program/Setting.vue";
import MembershipEarningPoints from "@/views/Membership/Program/EarningPoints/Index.vue";
import MembershipRedeemingPoints from "@/views/Membership/Program/RedeemPoints/Index.vue";
import MembershipBadges from "@/views/Membership/Program/Badges/Index.vue";
import MembershipFaqs from "@/views/Membership/Program/Faqs/Index.vue";

// Middlewares

import Auth from "@/middlewares/auth";
import Guest from "@/middlewares/guest";
import ActiveBusiness from "@/middlewares/activebusiness";
import NoActiveBusiness from "@/middlewares/noactivebusiness";
import NoActiveLocation from "@/middlewares/noactivelocation";
import CheckPermissions from "@/middlewares/checkpermissions";

const routes: any = [
  {
    path: "",
    name: "Login",
    component: LoginView,
    meta: {
      className: "login-main",
      navText: "Login" as String,
      middleware: [Guest],
    },
  },
  {
    path: "/login",
    name: "LoginLogin",
    component: LoginView,
    meta: {
      className: "login-main",
      navText: "Login" as String,
      middleware: [Guest],
    },
  },

  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: ForgotPassword,
    meta: {
      className: "forgot-password-main",
      navText: "ForgotPassword" as String,
      middleware: [Guest],
    },
  },

  {
    path: "/set-password", // set-password and reset is same for api match
    name: "SetPassword",
    component: SetPassword,
    meta: {
      className: "forgot-password-main",
      navText: "SetPassword" as String,
      middleware: [Guest],
    },
  },

  {
    path: "/reset-password",
    name: "ReSetPassword",
    component: SetPassword,
    meta: {
      className: "forgot-password-main",
      navText: "SetPassword" as String,
      middleware: [Guest],
    },
  },

  {
    path: "/select-business",
    name: "SelectBusiness",
    component: SelectBusiness,
    meta: {
      className: "select-business-main",
      navText: "Select Business",
      svg: `
         <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
         <path d="M9.75 6.75V0H18V6.75H9.75ZM0 9.75V0H8.25V9.75H0ZM9.75 18V8.25H18V18H9.75ZM0 18V11.25H8.25V18H0ZM1.5 8.25H6.75V1.5H1.5V8.25ZM11.25 16.5H16.5V9.75H11.25V16.5ZM11.25 5.25H16.5V1.5H11.25V5.25ZM1.5 16.5H6.75V12.75H1.5V16.5Z" fill="#878686"/>
         </svg>
         `,
      middleware: [Auth, NoActiveBusiness],
    },
  },
  {
    path: "/select-location",
    name: "SelectLocation",
    component: SelectLocation,
    meta: {
      className: "select-location-main",
      navText: "Select Location",
      svg: `
         <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
         <path d="M9.75 6.75V0H18V6.75H9.75ZM0 9.75V0H8.25V9.75H0ZM9.75 18V8.25H18V18H9.75ZM0 18V11.25H8.25V18H0ZM1.5 8.25H6.75V1.5H1.5V8.25ZM11.25 16.5H16.5V9.75H11.25V16.5ZM11.25 5.25H16.5V1.5H11.25V5.25ZM1.5 16.5H6.75V12.75H1.5V16.5Z" fill="#878686"/>
         </svg>
         `,
      middleware: [Auth, NoActiveLocation],
    },
  },

  {
    path: "/add-business",
    name: "AddBusiness",
    component: AddBusiness,
    meta: {
      className: "select-business-main",
      navText: "Select Business",
      svg: `
         <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
         <path d="M9.75 6.75V0H18V6.75H9.75ZM0 9.75V0H8.25V9.75H0ZM9.75 18V8.25H18V18H9.75ZM0 18V11.25H8.25V18H0ZM1.5 8.25H6.75V1.5H1.5V8.25ZM11.25 16.5H16.5V9.75H11.25V16.5ZM11.25 5.25H16.5V1.5H11.25V5.25ZM1.5 16.5H6.75V12.75H1.5V16.5Z" fill="#878686"/>
         </svg>
         `,
      middleware: [Auth, NoActiveBusiness],
    },
  },

  // {
  //   path: '/dashboard',
  //   name: 'Dashboard',
  //   component: Dashboard,
  //   meta: {
  //     navText: 'Dashboard',
  //     breadCrumbText: 'Dashboard',
  //     middleware: [Auth, ActiveBusiness],
  //     display: false,
  //     svg: `
  //       <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
  //       <path d="M9.75 6.75V0H18V6.75H9.75ZM0 9.75V0H8.25V9.75H0ZM9.75 18V8.25H18V18H9.75ZM0 18V11.25H8.25V18H0ZM1.5 8.25H6.75V1.5H1.5V8.25ZM11.25 16.5H16.5V9.75H11.25V16.5ZM11.25 5.25H16.5V1.5H11.25V5.25ZM1.5 16.5H6.75V12.75H1.5V16.5Z" fill="#878686"/>
  //       </svg>
  //       `
  //   }
  // },

  {
    path: "/dashboard",
    name: "ReportDashboard",
    component: ReportDashboard,
    meta: {
      middleware: [Auth, ActiveBusiness],
      navText: "Dashboard",
      breadCrumbText: "Dashboard",
      display: true,
      svg: `
        <svg width="15" height="15" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.75 6.75V0H18V6.75H9.75ZM0 9.75V0H8.25V9.75H0ZM9.75 18V8.25H18V18H9.75ZM0 18V11.25H8.25V18H0ZM1.5 8.25H6.75V1.5H1.5V8.25ZM11.25 16.5H16.5V9.75H11.25V16.5ZM11.25 5.25H16.5V1.5H11.25V5.25ZM1.5 16.5H6.75V12.75H1.5V16.5Z" fill="#fff"/>
        </svg>
        `,
    },
  },

  {
    path: "/clover-response/:locationId",
    name: "Clover",
    component: CloverResponse,
    meta: {
      // middleware: [Auth],
      navText: "Clover",
      breadCrumbText: "Clover",
      display: false,
      parent: "Clover",
      className: "clover-response-wrap",
    },
  },

  {
    name: "ProductMain",
    meta: {
      middleware: [Auth, ActiveBusiness],
      className: "products-main",
      navText: "Products",
      breadCrumbText: "Products",
      display: true,
      svg: `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.5 6.25L10 2.5L2.5 6.25M17.5 6.25V13.75L10 17.5M17.5 6.25L10 10M2.5 6.25V13.75L10 17.5M2.5 6.25L10 10M10 17.5V10M13.75 4.375L6.25 8.125" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>`,
    },
    children: [
      {
        path: "/products",
        name: "Products",
        component: Products,
        meta: {
          middleware: [Auth, ActiveBusiness],
          navText: "Product List",
          breadCrumbText: "Product List",
          display: true,
          parent: "",
        },
      },
      {
        path: "/master-products",
        name: "MasterProducts",
        component: MasterProducts,
        meta: {
          middleware: [Auth, ActiveBusiness],
          navText: "Master Product",
          breadCrumbText: "Master Product",
          display: true,
          displayUser: ["super"],
          parent: "",
        },
      },
      // {
      //   path: "/purchase-orders",
      //   name: "PurchaseOrders",
      //   component: PurchaseOrder,
      //   meta: {
      //     middleware: [Auth, ActiveBusiness],
      //     navText: "Purchase Orders",
      //     breadCrumbText: "Purchase Orders",
      //     display: true,
      //     parent: "",
      //   },
      // },
      {
        path: "/purchase-orders-v2",
        name: "PurchaseOrdersV2",
        component: PurchaseOrderV2,
        meta: {
          middleware: [Auth, ActiveBusiness],
          navText: "Purchase Orders",
          breadCrumbText: "Purchase Orders",
          display: true,
          parent: "",
        },
      },
      {
        path: "/purchase-orders/:id",
        name: "AddPurchaseOrders",
        component: AddPurchaseOrder,
        meta: {
          middleware: [Auth, ActiveBusiness],
          navText: "Purchase Orders",
          breadCrumbText: "Add Purchase Orders",
          display: false,
          parent: "",
        },
      },
      {
        path: "/purchase-orders-view/:id",
        name: "ViewPurchaseOrders",
        component: ViewPurchaseOrder,
        meta: {
          middleware: [Auth, ActiveBusiness],
          navText: "Purchase Orders Upload",
          breadCrumbText: "Purchase Orders Upload",
          display: false,
          parent: "",
        },
      },
      {
        path: "/product-categories",
        name: "ProductCategories",
        component: Categories,
        meta: {
          middleware: [Auth, ActiveBusiness],
          navText: "Categories",
          display: true,
          parent: "Products",
          breadCrumbText: "Regular Categories",
        },
      },
      {
        path: "/product-featured-categories",
        name: "ProductFeaturedCategories",
        component: FeaturedCategories,
        meta: {
          middleware: [Auth, ActiveBusiness],
          navText: "Categories",
          display: false,
          parent: "Products",
          breadCrumbText: "Featured Categories",
        },
      },

      // {
      //   path: '/purchase-orders',
      //   name: 'PurchaseOrders',
      //   component: Products,
      //   meta: {
      //     middleware: [Auth, ActiveBusiness],
      //     navText: 'Purchase Orders',
      //     breadCrumbText: 'Purchase Orders',
      //     display: true,
      //     parent: 'Products',
      //   }
      // },
      {
        path: "/product-promo-codes",
        name: "ProductPromotions",
        component: ProductPromotions,
        meta: {
          middleware: [Auth, ActiveBusiness],
          navText: "Promotions",
          breadCrumbText: "Promo codes",
          display: true,
          parent: "Products",
        },
      },

      {
        path: "/product-pre-set-discounts",
        name: "ProductDiscounts",
        component: ProductDiscounts,
        meta: {
          middleware: [Auth, ActiveBusiness],
          navText: "Promotions",
          breadCrumbText: "Pre-Set discounts",
          display: false,
          parent: "Products",
        },
      },
      {
        path: "/product-sales-promotions",
        name: "ProductSales",
        component: ProductSales,
        meta: {
          middleware: [Auth, ActiveBusiness],
          navText: "Promotions",
          breadCrumbText: "Promotions ",
          display: false,
          parent: "Products",
        },
      },
      {
        path: "/product-reason-code",
        name: "ProductReasonCode",
        component: ProductReasonCode,
        meta: {
          middleware: [Auth, ActiveBusiness],
          navText: "Reason",
          breadCrumbText: "Reason",
          display: false,
          parent: "Products",
        },
      },
    ],
  },
  {
    name: "Inventory",
    meta: {
      middleware: [Auth, ActiveBusiness],
      className: "inventory",
      navText: "Inventory",
      breadCrumbText: "Inventory",
      display: true,
      svg: `<svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.9167 16.6038L7.375 13.0622L8.54167 11.8955L10.9167 14.2705L15.625 9.56217L16.7917 10.7288L10.9167 16.6038ZM15.5 8.33301H13.8333V4.16634H12.1667V6.66634H3.83333V4.16634H2.16667V15.833H7.16667V17.4997H2.16667C1.70833 17.4997 1.31597 17.3365 0.989583 17.0101C0.663194 16.6837 0.5 16.2913 0.5 15.833V4.16634C0.5 3.70801 0.663194 3.31565 0.989583 2.98926C1.31597 2.66287 1.70833 2.49967 2.16667 2.49967H5.64583C5.79861 2.01356 6.09722 1.61426 6.54167 1.30176C6.98611 0.989258 7.47222 0.833008 8 0.833008C8.55556 0.833008 9.05208 0.989258 9.48958 1.30176C9.92708 1.61426 10.2222 2.01356 10.375 2.49967H13.8333C14.2917 2.49967 14.684 2.66287 15.0104 2.98926C15.3368 3.31565 15.5 3.70801 15.5 4.16634V8.33301ZM8 4.16634C8.23611 4.16634 8.43403 4.08648 8.59375 3.92676C8.75347 3.76704 8.83333 3.56912 8.83333 3.33301C8.83333 3.0969 8.75347 2.89898 8.59375 2.73926C8.43403 2.57954 8.23611 2.49967 8 2.49967C7.76389 2.49967 7.56597 2.57954 7.40625 2.73926C7.24653 2.89898 7.16667 3.0969 7.16667 3.33301C7.16667 3.56912 7.24653 3.76704 7.40625 3.92676C7.56597 4.08648 7.76389 4.16634 8 4.16634Z" fill="white"/>
        </svg>`,
    },
    children: [
      // audit
      {
        path: "/audits",
        name: "ProductAudits",
        component: ProductAudits,
        meta: {
          middleware: [Auth, ActiveBusiness, CheckPermissions],
          permissions: ["can_view_audit"],
          navText: "Audit",
          breadCrumbText: "Audit",
          display: true,
          parent: "Products",
        },
      },
      {
        path: "/inventory-overview",
        name: "InventoryOverview",
        component: InventoryOverview,
        meta: {
          middleware: [Auth, ActiveBusiness, CheckPermissions],
          permissions: [],
          navText: "Inventory Overview",
          breadCrumbText: "Inventory Overview",
          display: true,
          parent: "Products",
        },
      },
      {
        path: "/audits/:id/view",
        name: "ProductAuditsView",
        component: ProductAuditsView,
        meta: {
          middleware: [Auth, ActiveBusiness],
          navText: "Audit",
          breadCrumbText: "Adjustments",
          display: false,
          parent: "Transfer",
        },
      },
      // compliance report
      {
        path: "/compliance-report",
        name: "ComplianceReport",
        component: ComplianceReport,
        meta: {
          middleware: [Auth, ActiveBusiness, CheckPermissions],
          permissions: ['can_pull_compliance_reports'],
          navText: "Compliance Report",
          breadCrumbText: "Compliance Report",
          display: true,
          parent: "Transfer",
        },
      },
      // inventory
      {
        path: "/inventory-transfer",
        name: "Transfer",
        component: Transfer,
        meta: {
          middleware: [Auth, ActiveBusiness],
          navText: "Transfer",
          display: true,
          parent: "Transfer",
          breadCrumbText: "Transfer",
        },
      },
      {
        path: "/inventory-transfer-new",
        name: "NewTransfer",
        component: NewInventoryTransfers,
        meta: {
          middleware: [Auth, ActiveBusiness],
          navText: "Transfer",
          display: false,
          parent: "Transfer",
          breadCrumbText: "New Inventory Transfer",
        },
      },
      {
        path: "/inventory-transfer-edit/:id",
        name: "EditTransfer",
        component: EditInventoryTransfers,
        meta: {
          middleware: [Auth, ActiveBusiness],
          navText: "Transfer",
          display: false,
          parent: "Transfer",
          breadCrumbText: "Edit Inventory Transfer",
        },
      },
      {
        path: "/receive-transfer/:id",
        name: "ReceiveTransfer",
        component: ReceiveTransfer,
        meta: {
          middleware: [Auth, ActiveBusiness],
          navText: "Transfer",
          display: false,
          parent: "Transfer",
          breadCrumbText: "Receive Inventory Transfer",
        },
      },
      {
        path: "/location-cannabis-setting",
        name: "LocationCannabisSettings",
        component: LocationCannabisSettings,
        meta: {
          middleware: [Auth, ActiveBusiness],
          navText: "Settings",
          breadCrumbText: "Settings",
          parent: "LocationInfo",
          display: true,
        },
      },
    ],
  },
  {
    name: "MembershipAndCustomers",
    meta: {
      middleware: [Auth, ActiveBusiness, CheckPermissions],
      display: true,
      permissions: ["can_view_customer_details"],
      name: "MembershipAndCustomers",
      navText: "Customers",
      breadCrumbText: "Customers",
      svg: `
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.50033 10C9.10866 10 10.417 8.69167 10.417 7.08333C10.417 5.475 9.10866 4.16667 7.50033 4.16667C5.89199 4.16667 4.58366 5.475 4.58366 7.08333C4.58366 8.69167 5.89199 10 7.50033 10ZM1.66699 14.375C1.66699 12.4333 5.55033 11.4583 7.50033 11.4583C9.45033 11.4583 13.3337 12.4333 13.3337 14.375V15.8333H1.66699V14.375ZM7.50033 13.125C6.00866 13.125 4.31699 13.6833 3.61699 14.1667H11.3837C10.6837 13.6833 8.99199 13.125 7.50033 13.125ZM8.75033 7.08333C8.75033 6.39167 8.19199 5.83333 7.50033 5.83333C6.80866 5.83333 6.25033 6.39167 6.25033 7.08333C6.25033 7.775 6.80866 8.33333 7.50033 8.33333C8.19199 8.33333 8.75033 7.775 8.75033 7.08333ZM13.367 11.5083C14.3337 12.2083 15.0003 13.1417 15.0003 14.375V15.8333H18.3337V14.375C18.3337 12.6917 15.417 11.7333 13.367 11.5083ZM15.417 7.08333C15.417 8.69167 14.1087 10 12.5003 10C12.0503 10 11.6337 9.89167 11.2503 9.70833C11.7753 8.96667 12.0837 8.05833 12.0837 7.08333C12.0837 6.10833 11.7753 5.2 11.2503 4.45833C11.6337 4.275 12.0503 4.16667 12.5003 4.16667C14.1087 4.16667 15.417 5.475 15.417 7.08333Z" fill="white"/>
      </svg>

        `,
    },
    children: [
      {
        path: "/membership-customers",
        name: "MembershipCustomerList",
        component: MembershipCustomers,
        meta: {
          middleware: [Auth, ActiveBusiness, CheckPermissions],
          permissions: ["can_view_customer_details"],
          navText: "Customer List",
          breadCrumbText: "Customer List",
          display: true,
          parent: "",
        },
      },
    ],
  },

  {
    name: "Membership",
    meta: {
      middleware: [Auth, ActiveBusiness],
      display: true,
      name: "Membership",
      navText: "Membership",
      breadCrumbText: "Membership",
      svg: `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="white" d="M18,19H6V17.6C6,15.6 10,14.5 12,14.5C14,14.5 18,15.6 18,17.6M12,7A3,3 0 0,1 15,10A3,3 0 0,1 12,13A3,3 0 0,1 9,10A3,3 0 0,1 12,7M12,3A1,1 0 0,1 13,4A1,1 0 0,1 12,5A1,1 0 0,1 11,4A1,1 0 0,1 12,3M19,3H14.82C14.4,1.84 13.3,1 12,1C10.7,1 9.6,1.84 9.18,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3Z" /></svg>
        `,
    },
    children: [
      {
        path: "/membership-setting",
        name: "MembershipSetting",
        component: MembershipSetting,
        meta: {
          middleware: [Auth, ActiveBusiness, CheckPermissions],
          navText: "Membership Settings",
          breadCrumbText: "Membership Settings",
          display: true,
          parent: "MembershipCustomerList",
        },
      },

      {
        path: "/membership-earning-points",
        name: "MembershipEarningPoints",
        component: MembershipEarningPoints,
        meta: {
          middleware: [Auth, ActiveBusiness],
          navText: "Earning",
          breadCrumbText: "Earning",
          display: false,
          parent: "MembershipAndCustomers",
        },
      },

      {
        path: "/membership-redeeming-points",
        name: "MembershipRedeemingPoints",
        component: MembershipRedeemingPoints,
        meta: {
          middleware: [Auth, ActiveBusiness],
          navText: "Redeeming",
          breadCrumbText: "Redeeming",
          display: false,
          parent: "MembershipAndCustomers",
        },
      },

      {
        path: "/membership-badges",
        name: "MembershipBadges",
        component: MembershipBadges,
        meta: {
          middleware: [Auth, ActiveBusiness],
          navText: "Badges",
          breadCrumbText: "Badges",
          display: false,
          parent: "MembershipAndCustomers",
        },
      },

      {
        path: "/membership-faqs",
        name: "MembershipFaqs",
        component: MembershipFaqs,
        meta: {
          middleware: [Auth, ActiveBusiness],
          navText: "F.A.Q",
          breadCrumbText: "F.A.Q",
          display: false,
          parent: "MembershipAndCustomers",
        },
      },
    ],
  },

  {
    name: "Analytics",
    meta: {
      navText: "Analytics",
      breadCrumbText: "Analytics",
      middleware: [Auth, ActiveBusiness],
      display: true,
      svg: `
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.18717 15.1458L0.833008 14.1667L4.99967 7.5L7.49967 10.4167L10.833 5L13.1038 8.39583C12.7844 8.40972 12.4822 8.44777 12.1972 8.51C11.9127 8.57277 11.6316 8.65972 11.3538 8.77083L10.8955 8.08333L7.72884 13.2292L5.20801 10.2917L2.18717 15.1458ZM17.9788 19.1667L15.3747 16.5625C15.0969 16.7569 14.7877 16.9028 14.4472 17C14.1072 17.0972 13.7566 17.1458 13.3955 17.1458C12.3538 17.1458 11.4686 16.7811 10.7397 16.0517C10.0102 15.3228 9.64551 14.4375 9.64551 13.3958C9.64551 12.3542 10.0102 11.4686 10.7397 10.7392C11.4686 10.0103 12.3538 9.64583 13.3955 9.64583C14.4372 9.64583 15.3227 10.0103 16.0522 10.7392C16.7811 11.4686 17.1455 12.3542 17.1455 13.3958C17.1455 13.7569 17.0969 14.1075 16.9997 14.4475C16.9025 14.7881 16.7566 15.1042 16.5622 15.3958L19.1663 17.9792L17.9788 19.1667ZM13.3955 15.4792C13.9788 15.4792 14.4719 15.2778 14.8747 14.875C15.2775 14.4722 15.4788 13.9792 15.4788 13.3958C15.4788 12.8125 15.2775 12.3194 14.8747 11.9167C14.4719 11.5139 13.9788 11.3125 13.3955 11.3125C12.8122 11.3125 12.3191 11.5139 11.9163 11.9167C11.5136 12.3194 11.3122 12.8125 11.3122 13.3958C11.3122 13.9792 11.5136 14.4722 11.9163 14.875C12.3191 15.2778 12.8122 15.4792 13.3955 15.4792ZM15.2497 8.8125C14.9858 8.70139 14.7113 8.61111 14.4263 8.54166C14.1419 8.47222 13.8469 8.43055 13.5413 8.41666L17.8122 1.66666L19.1663 2.64583L15.2497 8.8125Z" fill="white"/>
      </svg>
      `,
    },
    children: [
      {
        path: "/analytics",
        name: "ReportGeneration",
        component: ReportGeneration,
        meta: {
          middleware: [Auth, ActiveBusiness],
          navText: "Insights",
          breadCrumbText: "Insights",
          display: true,
          parent: "",
        },
      },
      {
        path: "/sales",
        name: "SalesMain",
        component: SalesMain,
        meta: {
          middleware: [Auth, ActiveBusiness, CheckPermissions],
          permissions: ["can_view_past_sales"],
          navText: "Sales Summary",
          breadCrumbText: "Sales Summary",
          display: true,
          parent: "",
        },
      },
      {
        path: "/inventory-snap-shots",
        name: "InventorySnapShots",
        component: InventorySnapShots,
        meta: {
          middleware: [Auth, ActiveBusiness],
          navText: "Inventory Snapshot",
          breadCrumbText: "Inventory Snapshot",
          display: true,
          parent: "",
        },
      },
      // {
      //   path: '/invoice-report',
      //   name: 'InvoiceReport',
      //   component: InvoiceReport,
      //   meta: {
      //     middleware: [Auth, ActiveBusiness],
      //     navText: 'Invoices',
      //     breadCrumbText: 'Invoices',
      //     display: true,
      //     parent: ''
      //   }
      // },
      // {
      //   path: '/discount',
      //   name: 'Discounts',
      //   component: Discounts,
      //   meta: {
      //     middleware: [Auth, ActiveBusiness],
      //     navText: 'Discounts',
      //     breadCrumbText: 'Discounts',
      //     display: true,
      //     parent: ''
      //   }
      // },
      {
        path: "/taxes",
        name: "Taxes",
        component: Taxes,
        meta: {
          middleware: [Auth, ActiveBusiness],
          navText: "Taxes",
          breadCrumbText: "Taxes",
          display: true,
          parent: "",
        },
      },
      {
        path: "/transfer-report",
        name: "TransferReport",
        component: TransferReport,
        meta: {
          middleware: [Auth, ActiveBusiness],
          navText: "Transfer Report",
          breadCrumbText: "Transfer Report",
          display: true,
          parent: "",
        },
      },
      {
        path: "/inventory-log",
        name: "InventoryLog",
        component: InventoryLog,
        meta: {
          middleware: [Auth, ActiveBusiness],
          navText: "Inventory Logs",
          breadCrumbText: "Inventory Logs",
          display: true,
          parent: "",
        },
      },
      {
        path: "/purchase-order-report",
        name: "PurchaseOrderReport",
        component: PurchaseOrderReport,
        meta: {
          middleware: [Auth, ActiveBusiness],
          navText: "Purchase Order",
          breadCrumbText: "Purchase Order",
          display: true,
          parent: "",
        },
      },
      {
        path: "/end-of-day-summary",
        name: "eodSummary",
        component: EodSummary,
        meta: {
          middleware: [Auth, ActiveBusiness],
          navText: "End of Day Summary",
          breadCrumbText: "End of Day Summary",
          display: true,
          parent: "",
        },
      },
    ],
  },

  {
    name: "Cash",
    meta: {
      navText: "Cash Mgmt.",
      breadCrumbText: "Cash Mgmt.",
      middleware: [Auth, ActiveBusiness],
      display: true,
      svg: `
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.99996 1.66675C5.39996 1.66675 1.66663 5.40008 1.66663 10.0001C1.66663 14.6001 5.39996 18.3334 9.99996 18.3334C14.6 18.3334 18.3333 14.6001 18.3333 10.0001C18.3333 5.40008 14.6 1.66675 9.99996 1.66675ZM9.99996 16.6667C6.32496 16.6667 3.33329 13.6751 3.33329 10.0001C3.33329 6.32508 6.32496 3.33341 9.99996 3.33341C13.675 3.33341 16.6666 6.32508 16.6666 10.0001C16.6666 13.6751 13.675 16.6667 9.99996 16.6667ZM8.30829 7.89175C8.30829 8.50008 8.78329 8.90841 10.2583 9.28341C11.725 9.66675 13.3 10.3001 13.3083 12.1334C13.3 13.4751 12.3 14.2001 11.0333 14.4417V15.8334H9.08329V14.4167C7.83329 14.1584 6.78329 13.3584 6.69996 11.9417H8.13329C8.20829 12.7084 8.73329 13.3084 10.0666 13.3084C11.4916 13.3084 11.8166 12.5917 11.8166 12.1501C11.8166 11.5501 11.4916 10.9751 9.86663 10.5917C8.05829 10.1584 6.81663 9.40841 6.81663 7.91675C6.81663 6.65841 7.82496 5.84175 9.08329 5.57508V4.16675H11.025V5.59175C12.375 5.92508 13.0583 6.95008 13.1 8.06675H11.675C11.6416 7.25008 11.2083 6.70008 10.0583 6.70008C8.96663 6.70008 8.30829 7.19175 8.30829 7.89175Z" fill="white"/>
      </svg>
      `,
    },
    children: [
      {
        path: "/reports-end-of-day",
        name: "reportEod",
        component: EndOfDay,
        meta: {
          middleware: [Auth, ActiveBusiness],
          navText: "End of day",
          breadCrumbText: "End of day",
          display: true,
          parent: "",
        },
      },
      {
        path: "/current-vault",
        name: "CurrentVault",
        component: CurrentVault,
        meta: {
          middleware: [Auth, ActiveBusiness, CheckPermissions],
          permissions: ["can_view_or_manage_vault"],
          navText: "Vault",
          display: true,
          parent: "Vault",
          breadCrumbText: "Current Vault",
        },
      },
      {
        path: "/transaction-history",
        name: "TransactionHistory",
        component: TransactionHistory,
        meta: {
          middleware: [Auth, ActiveBusiness],
          navText: "Vault",
          display: false,
          parent: "Vault",
          breadCrumbText: "Transaction History",
        },
      },
    ],
  },

  {
    name: "Employees",
    meta: {
      middleware: [Auth, ActiveBusiness],
      display: true,
      name: "Employee List",
      navText: "Employees",
      breadCrumbText: "Employees",
      svg: `
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.33366 18.3333C2.87533 18.3333 2.4831 18.1703 2.15699 17.8442C1.83033 17.5175 1.66699 17.125 1.66699 16.6667V7.5C1.66699 7.04167 1.83033 6.64917 2.15699 6.3225C2.4831 5.99639 2.87533 5.83333 3.33366 5.83333H7.50033V3.33333C7.50033 2.875 7.66366 2.4825 7.99033 2.15583C8.31644 1.82972 8.70866 1.66667 9.16699 1.66667H10.8337C11.292 1.66667 11.6845 1.82972 12.0112 2.15583C12.3373 2.4825 12.5003 2.875 12.5003 3.33333V5.83333H16.667C17.1253 5.83333 17.5178 5.99639 17.8445 6.3225C18.1706 6.64917 18.3337 7.04167 18.3337 7.5V16.6667C18.3337 17.125 18.1706 17.5175 17.8445 17.8442C17.5178 18.1703 17.1253 18.3333 16.667 18.3333H3.33366ZM3.33366 16.6667H16.667V7.5H12.5003C12.5003 7.95833 12.3373 8.35056 12.0112 8.67667C11.6845 9.00333 11.292 9.16667 10.8337 9.16667H9.16699C8.70866 9.16667 8.31644 9.00333 7.99033 8.67667C7.66366 8.35056 7.50033 7.95833 7.50033 7.5H3.33366V16.6667ZM5.00033 15H10.0003V14.625C10.0003 14.3889 9.93421 14.17 9.80199 13.9683C9.67033 13.7672 9.48644 13.6111 9.25033 13.5C8.97255 13.375 8.69144 13.2814 8.40699 13.2192C8.12199 13.1564 7.81977 13.125 7.50033 13.125C7.18088 13.125 6.87894 13.1564 6.59449 13.2192C6.30949 13.2814 6.0281 13.375 5.75033 13.5C5.51421 13.6111 5.33033 13.7672 5.19866 13.9683C5.06644 14.17 5.00033 14.3889 5.00033 14.625V15ZM11.667 13.75H15.0003V12.5H11.667V13.75ZM7.50033 12.5C7.84755 12.5 8.14255 12.3783 8.38533 12.135C8.62866 11.8922 8.75033 11.5972 8.75033 11.25C8.75033 10.9028 8.62866 10.6078 8.38533 10.365C8.14255 10.1217 7.84755 10 7.50033 10C7.1531 10 6.8581 10.1217 6.61533 10.365C6.37199 10.6078 6.25033 10.9028 6.25033 11.25C6.25033 11.5972 6.37199 11.8922 6.61533 12.135C6.8581 12.3783 7.1531 12.5 7.50033 12.5ZM11.667 11.25H15.0003V10H11.667V11.25ZM9.16699 7.5H10.8337V3.33333H9.16699V7.5Z" fill="white"/>
        </svg>
        `,
    },
    children: [
      {
        path: "/employees",
        name: "EmployeesList",
        component: Employees,
        meta: {
          middleware: [Auth, ActiveBusiness],
          navText: "Employee List",
          breadCrumbText: "Employee List",
          display: true,
          parent: "",
        },
      },
      {
        path: "/security-roles",
        name: "SecurityRoles",
        component: SecurityRoles,
        meta: {
          middleware: [Auth, ActiveBusiness, CheckPermissions],
          permissions: ["can_create_update_roles_permission"],
          navText: "Security Roles",
          breadCrumbText: "Security Roles",
          display: true,
          parent: "EmployeesList",
        },
      },
    ],
  },

  {
    name: "Locations",
    meta: {
      navText: "Locations",
      breadCrumbText: "Location",
      middleware: [Auth, ActiveBusiness],
      display: true,
      svg: `
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.99967 10C10.458 10 10.8505 9.83667 11.1772 9.51C11.5033 9.18389 11.6663 8.79167 11.6663 8.33334C11.6663 7.87501 11.5033 7.48251 11.1772 7.15584C10.8505 6.82973 10.458 6.66667 9.99967 6.66667C9.54134 6.66667 9.14912 6.82973 8.82301 7.15584C8.49634 7.48251 8.33301 7.87501 8.33301 8.33334C8.33301 8.79167 8.49634 9.18389 8.82301 9.51C9.14912 9.83667 9.54134 10 9.99967 10ZM9.99967 16.125C11.6941 14.5695 12.9511 13.1561 13.7705 11.885C14.59 10.6145 14.9997 9.48612 14.9997 8.50001C14.9997 6.98612 14.5169 5.74639 13.5513 4.78084C12.5863 3.81584 11.4025 3.33334 9.99967 3.33334C8.5969 3.33334 7.41273 3.81584 6.44717 4.78084C5.48217 5.74639 4.99967 6.98612 4.99967 8.50001C4.99967 9.48612 5.4094 10.6145 6.22884 11.885C7.04829 13.1561 8.30523 14.5695 9.99967 16.125ZM9.99967 18.0208C9.88856 18.0208 9.77745 18 9.66634 17.9583C9.55523 17.9167 9.45801 17.8611 9.37467 17.7917C7.3469 16 5.83301 14.337 4.83301 12.8025C3.83301 11.2675 3.33301 9.83334 3.33301 8.50001C3.33301 6.41667 4.00329 4.75695 5.34384 3.52084C6.68384 2.28473 8.23579 1.66667 9.99967 1.66667C11.7636 1.66667 13.3155 2.28473 14.6555 3.52084C15.9961 4.75695 16.6663 6.41667 16.6663 8.50001C16.6663 9.83334 16.1663 11.2675 15.1663 12.8025C14.1663 14.337 12.6525 16 10.6247 17.7917C10.5413 17.8611 10.4441 17.9167 10.333 17.9583C10.2219 18 10.1108 18.0208 9.99967 18.0208Z" fill="white"/>
        </svg>      
        `,
    },
    children: [
      {
        path: "/location-info",
        name: "LocationInfo",
        component: LocationInfo,
        meta: {
          middleware: [Auth, ActiveBusiness],
          navText: "Location Settings",
          breadCrumbText: "Location Settings",
          parent: "",
          display: true,
        },
      },
      {
        path: "/location-holidays",
        name: "LocationLocationHolidays",
        component: LocationHolidays,
        meta: {
          middleware: [Auth, ActiveBusiness],
          navText: "Holidays",
          breadCrumbText: "Holidays",
          parent: "LocationInfo",
          display: true,
        },
      },

      {
        path: "/location-device-pos-stations",
        name: "LocationDevicesPos",
        component: LocationDevicesPos,
        meta: {
          middleware: [Auth, ActiveBusiness],
          navText: "Devices",
          breadCrumbText: "Pos Stations",
          parent: "LocationInfo",
          display: true,
        },
      },
      {
        path: "/location-device-scanner",
        name: "LocationDeviceScanner",
        component: LocationDeviceScanner,
        meta: {
          middleware: [Auth, ActiveBusiness],
          navText: "Devices",
          breadCrumbText: "Scanners",
          parent: "LocationInfo",
          display: false,
        },
      },

      {
        path: "/location-delivery-setting",
        name: "LocationDeliverySetting",
        component: LocationDeliverySetting,
        meta: {
          middleware: [Auth, ActiveBusiness],
          navText: "Delivery",
          breadCrumbText: "Delivery Setting",
          parent: "LocationInfo",
          display: true,
        },
      },
      {
        path: "/location-delivery-hours",
        name: "LocationDeliveryHours",
        component: LocationDeliveryHours,
        meta: {
          middleware: [Auth, ActiveBusiness],
          navText: "Delivery",
          breadCrumbText: "Delivery Hours",
          parent: "LocationInfo",
          display: false,
        },
      },
      {
        path: "/location-delivery-zone",
        name: "LocationDeliveryZone",
        component: LocationDeliveryZone,
        meta: {
          middleware: [Auth, ActiveBusiness],
          navText: "Delivery",
          breadCrumbText: "Delivery Zones",
          parent: "LocationInfo",
          display: false,
        },
      },

      {
        path: "/location-pickup",
        name: "LocationPickup",
        component: LocationPickup,
        meta: {
          middleware: [Auth, ActiveBusiness],
          navText: "Pick-Up",
          breadCrumbText: "Pick-Up",
          parent: "LocationInfo",
          display: true,
        },
      },

      {
        path: "/location-integrations-payment",
        name: "LocationIntegrationPayment",
        component: LocationIntegrationPayment,
        meta: {
          middleware: [Auth, ActiveBusiness],
          navText: "Integrations",
          breadCrumbText: "Payments",
          parent: "LocationInfo",
          display: true,
        },
      },

      // {
      //   path: '/location-hespler-pos1',
      //   name: 'Locationhesplerpos1',
      //   component: HesplerPos1,
      //   meta: {
      //     middleware: [Auth, ActiveBusiness],
      //     navText: 'Hespler Pos 1',
      //     parent: 'LocationInfo',
      //     display: true,
      //   }
      // },

      {
        path: "/location-integrations-crm",
        name: "LocationIntegrationsCrm",
        component: LocationIntegrationCRM,
        meta: {
          middleware: [Auth, ActiveBusiness],
          navText: "Integrations",
          breadCrumbText: "CRM",
          parent: "LocationInfo",
          display: false,
        },
      },
      {
        path: "/location-integrations-access-tokens",
        name: "LocationIntegrationAccessToken",
        component: LocationIntegrationAccessToken,
        meta: {
          middleware: [Auth, ActiveBusiness],
          navText: "Integrations",
          breadCrumbText: "Access tokens",
          parent: "LocationInfo",
          display: false,
        },
      },
      {
        path: "/location-integrations-compliance-setting",
        name: "LocationComplianceSettings",
        component: LocationComplianceSettings,
        meta: {
          middleware: [Auth, ActiveBusiness],
          navText: "Integrations",
          breadCrumbText: "Compliance",
          parent: "LocationInfo",
          display: false,
        },
      },
      {
        path: "/marketplace",
        name: "Marketplace",
        component: Marketplace,
        meta: {
          middleware: [Auth, ActiveBusiness],
          navText: "Integrations",
          breadCrumbText: "Marketplace",
          parent: "LocationInfo",
          display: false,
        },
      },

      {
        path: "/location-message-banner",
        name: "LocationMessageBanner",
        component: LocationMessageBanner,
        meta: {
          middleware: [Auth, ActiveBusiness],
          navText: "Message banner",
          breadCrumbText: "Message banner",
          parent: "LocationInfo",
          display: true,
        },
      },

      {
        path: "/price-markup-setting",
        name: "PriceMarkupSetting",
        component: PriceMarkupSetting,
        meta: {
          middleware: [Auth, ActiveBusiness],
          navText: "Price Markup Settings",
          breadCrumbText: "Price Markup Settings",
          parent: "LocationInfo",
          display: true,
        },
      },
    ],
  },

  // {
  //   name: 'Banner',
  //   meta: {
  //     navText: 'Banner',
  //     breadCrumbText: 'Banner',
  //     middleware: [Auth, ActiveBusiness],
  //     display: false,
  //     svg: `<svg width="20" height="20" fill="white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M20,5A2,2 0 0,1 22,7V17A2,2 0 0,1 20,19H4C2.89,19 2,18.1 2,17V7C2,5.89 2.89,5 4,5H20M5,16H19L14.5,10L11,14.5L8.5,11.5L5,16Z" /></svg>`
  //   },
  //   children: [
  //   ]
  // },

  {
    name: "Settings",
    meta: {
      navText: "Settings",
      breadCrumbText: "Settings",
      middleware: [Auth, ActiveBusiness],
      display: true,
      svg: `
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.08366 18.3333L7.66699 15.7083C7.4031 15.6111 7.12533 15.4792 6.83366 15.3125C6.54199 15.1458 6.28505 14.9722 6.06283 14.7917L3.60449 15.9167L1.66699 12.5L3.91699 10.8542C3.88921 10.7292 3.87185 10.5868 3.86491 10.4271C3.85796 10.2674 3.85449 10.125 3.85449 10C3.85449 9.87501 3.85796 9.73264 3.86491 9.57292C3.87185 9.4132 3.88921 9.27084 3.91699 9.14584L1.66699 7.50001L3.60449 4.08334L6.06283 5.20834C6.28505 5.02778 6.54199 4.85417 6.83366 4.68751C7.12533 4.52084 7.4031 4.39584 7.66699 4.31251L8.08366 1.66667H11.917L12.3337 4.29167C12.5975 4.38889 12.8788 4.51737 13.1774 4.67709C13.476 4.83681 13.7295 5.01389 13.9378 5.20834L16.3962 4.08334L18.3337 7.50001L16.0837 9.10417C16.1114 9.24306 16.1288 9.39237 16.1357 9.55209C16.1427 9.71181 16.1462 9.86112 16.1462 10C16.1462 10.1389 16.1427 10.2847 16.1357 10.4375C16.1288 10.5903 16.1114 10.7361 16.0837 10.875L18.3337 12.5L16.3962 15.9167L13.9378 14.7917C13.7156 14.9722 13.4621 15.1493 13.1774 15.3229C12.8927 15.4965 12.6114 15.625 12.3337 15.7083L11.917 18.3333H8.08366ZM10.0003 12.7083C10.7503 12.7083 11.3892 12.4445 11.917 11.9167C12.4448 11.3889 12.7087 10.75 12.7087 10C12.7087 9.25001 12.4448 8.61112 11.917 8.08334C11.3892 7.55556 10.7503 7.29167 10.0003 7.29167C9.25033 7.29167 8.61144 7.55556 8.08366 8.08334C7.55588 8.61112 7.29199 9.25001 7.29199 10C7.29199 10.75 7.55588 11.3889 8.08366 11.9167C8.61144 12.4445 9.25033 12.7083 10.0003 12.7083ZM10.0003 11.4583C9.59755 11.4583 9.2538 11.316 8.96908 11.0313C8.68435 10.7465 8.54199 10.4028 8.54199 10C8.54199 9.59723 8.68435 9.25348 8.96908 8.96876C9.2538 8.68403 9.59755 8.54167 10.0003 8.54167C10.4031 8.54167 10.7469 8.68403 11.0316 8.96876C11.3163 9.25348 11.4587 9.59723 11.4587 10C11.4587 10.4028 11.3163 10.7465 11.0316 11.0313C10.7469 11.316 10.4031 11.4583 10.0003 11.4583ZM9.08366 17.0833H10.917L11.2087 14.75C11.667 14.6389 12.101 14.4653 12.5107 14.2292C12.9205 13.9931 13.292 13.7083 13.6253 13.375L15.8337 14.3333L16.667 12.8333L14.7087 11.3958C14.7642 11.1597 14.8094 10.9271 14.8441 10.6979C14.8788 10.4688 14.8962 10.2361 14.8962 10C14.8962 9.76389 14.8823 9.53126 14.8545 9.30209C14.8267 9.07292 14.7781 8.84028 14.7087 8.60417L16.667 7.16667L15.8337 5.66667L13.6253 6.62501C13.3059 6.26389 12.9448 5.96181 12.542 5.71876C12.1392 5.4757 11.6948 5.31945 11.2087 5.25001L10.917 2.91667H9.08366L8.79199 5.25001C8.31977 5.34723 7.8788 5.51389 7.46908 5.75001C7.05935 5.98612 6.69477 6.27778 6.37533 6.62501L4.16699 5.66667L3.33366 7.16667L5.29199 8.60417C5.23644 8.84028 5.1913 9.07292 5.15658 9.30209C5.12185 9.53126 5.10449 9.76389 5.10449 10C5.10449 10.2361 5.12185 10.4688 5.15658 10.6979C5.1913 10.9271 5.23644 11.1597 5.29199 11.3958L3.33366 12.8333L4.16699 14.3333L6.37533 13.375C6.70866 13.7083 7.08019 13.9931 7.48991 14.2292C7.89963 14.4653 8.33366 14.6389 8.79199 14.75L9.08366 17.0833Z" fill="white"/>
        </svg>
      `,
    },
    children: [
      // {
      //   path: "/general-settings",
      //   name: "GeneralSettings",
      //   component: GeneralSettings,
      //   meta: {
      //     middleware: [Auth, ActiveBusiness],
      //     navText: "General",
      //     breadCrumbText: "General",
      //     display: true,
      //     parent: "Settings",
      //   },
      // },
      {
        path: "/general-profile",
        name: 'SettingGeneralProfile',
        component: SettingGeneralProfile,
        meta: {
          middleware: [Auth, ActiveBusiness],
          navText: "General",
          breadCrumbText: "Profiles",
          display: true,
          parent: "Settings",
        },
      },
      {
        path: "/general-business",
        name: 'SettingGeneralBusiness',
        component: SettingGeneralBusiness,
        meta: {
          middleware: [Auth, ActiveBusiness],
          navText: "General",
          breadCrumbText: "Business",
          display: false,
          parent: "Settings",
        },
      },
      {
        path: "/pricing-group",
        name: "PricingGroup",
        component: PricingGroup,
        meta: {
          middleware: [Auth, ActiveBusiness],
          navText: "Pricing Group",
          breadCrumbText: "Pricing Group",
          display: true,
          parent: "Settings",
        },
      },
      {
        path: "/banner",
        name: "Banner",
        component: Banner,
        meta: {
          middleware: [Auth, ActiveBusiness],
          navText: "Banners",
          breadCrumbText: "Banners",
          display: true,
          name: "Banner",
        },
      },
      // {
      //   path: '/business-cannabis-settings',
      //   name: 'BusinessCannabisSettings',
      //   component: BusinessCannabisSettings,
      //   meta: {
      //     middleware: [Auth, ActiveBusiness],
      //     navText: 'Cannabis Settings',
      //     breadCrumbText: 'Business Cannabis Settings',
      //     display: true,
      //     parent: 'Settings'
      //   }
      // },
      // {
      //   path: "/website-settings",
      //   name: "WebsiteSettings",
      //   component: WebsiteSettings,
      //   meta: {
      //     middleware: [Auth, ActiveBusiness],
      //     navText: "Website Settings",
      //     breadCrumbText: "Website Settings",
      //     display: true,
      //     parent: "Settings",
      //   },
      // },
      // {
      //   path: "/seo-settings",
      //   name: "SeoSettings",
      //   component: SeoSettings,
      //   meta: {
      //     middleware: [Auth, ActiveBusiness],
      //     navText: "SEO Settings",
      //     breadCrumbText: "SEO Settings",
      //     display: true,
      //     parent: "Settings",
      //   },
      // },
      {
        path: "/business-taxes",
        name: "BusinessTaxes",
        component: BusinessTaxes,
        meta: {
          middleware: [Auth, ActiveBusiness],
          navText: "Taxes & Fees",
          breadCrumbText: "Taxes & Fees",
          parent: "LocationInfo",
          display: true,
          name: "Taxes",
        },
      },

      {
        path: "/product-import",
        name: "ProductImport",
        component: ProductImport,
        meta: {
          middleware: [Auth, ActiveBusiness, CheckPermissions],
          permissions: ["can_view_tools"],
          navText: "Tools",
          display: true,
          parent: "LocationInfo",
          breadCrumbText: "Product Import",
        },
      },
      {
        path: "/customer-import",
        name: "CustomerImport",
        component: CustomerImport,
        meta: {
          middleware: [Auth, ActiveBusiness],
          navText: "Tools",
          display: false,
          parent: "LocationInfo",
          breadCrumbText: "Customer Import",
        },
      },
      {
        path: '/purchase-order-ai-promots',
        name: 'PurchaseOrderAIPrompts',
        component: PurchaseOrderAIPrompts,
        meta: {
          middleware: [Auth, ActiveBusiness],
          navText: "Tools",
          display: false,
          parent: "LocationInfo",
          breadCrumbText: "Purchase Order AI Prompts",
        },
      }
      // {
      //   path: '/tools',
      //   name: 'Tools',
      //   component: Tools,
      //   meta: {
      //     middleware: [Auth, ActiveBusiness],
      //     navText: 'Tools',
      //     breadCrumbText: 'Tools',
      //     parent: 'LocationInfo',
      //     display: true,
      //     name: 'Setting',
      //   }
      // }
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

let backButton = false;
window.addEventListener("popstate", async function (e) {
  if (
    (e.state?.forward?.includes("/audits") &&
    e.state?.forward?.includes("/view") &&
    !store.getters["audit/completed"]) || (e.state?.forward?.includes("/products") && !store.getters["purchaseOrderWarn/show"])
  ) {
    e.preventDefault();
    backButton = true;
  }
});
window.addEventListener("beforeunload", async function(e){
  if(store.getters["modifiedForm/status"]){
    e.preventDefault();
    e.returnValue = true;
  }
});

router.beforeEach(async (to, from, next) => {
  if (from.name == "ProductAuditsView" && !store.getters["audit/completed"]) {
    await store.dispatch("confirmNew/confirmNew", {
        msg: "Exit",
        extraMsg:
          "Are you sure you want to leave without completing the audit?",
        confirmText: "Yes, Exit",
        confirmClass: "bg-theme-red hover:bg-opacity-70 text-white",
    }).then(() => {
      store.dispatch("audit/setAudit", true);
      next()
    }).catch(e => {
      if(backButton){
        history.go(1)
      }else{
        return false
      }
      console.log(e)
    })
  }else if(from.name=="AddPurchaseOrders" && to.name!=='AddPurchaseOrders' && store.getters["purchaseOrderWarn/show"]){
    await store.dispatch("confirmNew/confirmNew", {
      msg: "Cancel",
      extraMsg:
        "This Purchase Order is in progress, are you sure you want to leave? Your Progress is saved and you can return at any time.",
      confirmText: "Yes",
      confirmClass: "bg-[#DC3545] text-white",
    }).then(() => {
      store.dispatch("purchaseOrderWarn/setPurchaseOrderWarning", false);
      next()
    }).catch(e => {
      console.log(e)
      return false
    })
  }else if(store.getters["modifiedForm/status"]){
    await store.dispatch("confirmNew/confirmNew", {
      msg: "Leave?",
      extraMsg:
        "Are you sure you want to leave? Your changes have not been saved",
      confirmText: "Yes",
      confirmClass: "bg-white text-theme-red",
      cancelText: "No",
      cancelClass: "bg-theme-green text-white",
      confirmLeft: true
    }).then(() => {
      store.dispatch('modifiedForm/setStatus', false)
      next()
    }).catch(() => {
      if(backButton){
        history.go(1)
      }else{
        return false
      }
    })
  } else {
    next();
  }
  backButton = false;
});

export default router;
